export default {
  // Tab 标签
  评估: "Evaluation",

  // 搜索字段标签
  供应商编号: "Supplier Number",
  供应商名称: "Supplier Name",
  物料编号: "Material Number",
  物料名称: "Material Name",
  评估状态: "Admission Assessment Status",
  申请人: "Applicant",
  请输入供应商编号: "Please Enter Supplier Number",
  请输入供应商名称: "Please Enter Supplier Name",
  请输入物料编号: "Please Enter Material Number",
  请输入物料名称: "Please Enter Material Name",
  请选评估状态: "Please Select Admission Assessment Status",
  请输入申请人名字: "Please Enter Applicant Name",

  // 表格列标题
  评估发起人: "Assessment Initiator",
  发起时间: "Initiation Time",
  操作: "Action",

  // 表格标题
  评估列表: "Assessment List",

  // 按钮文本
  申请评估: "Apply for Assessment",
  编辑: "Edit",
  删除: "Delete",
  查看: "View",
  发起VSMC会议: "Initiate VSMC Meeting",
  重新评估: "Reassess",
  暂存: "Save as Draft",
  提交: "Submit",

  // 评估状态值
  草稿: "Draft",
  部门评估中: "Department Assessment In Progress",
  部门评估完成: "Department Assessment Completed",
  审批中: "Under Review",
  已驳回: "Rejected",
  已通过: "Approved",

  // 消息提示
  获取用户列表失败: "Failed to Get User List",
  获取评估数据失败: "Failed to Get Assessment Data",
  "获取评估数据失败，请重试": "Failed to Get Assessment Data, Please Try Again",
  评估申请已成功提交: "Assessment Application Submitted Successfully",
  "提交失败，请重试": "Submission Failed, Please Try Again",
  提交评估申请失败: "Failed to Submit Assessment Application",
  "提交评估申请失败，请重试":
    "Failed to Submit Assessment Application, Please Try Again",
  删除功能开发中: "Delete Function Under Development",
  搜索参数: "Search Parameters",
  重置搜索: "Reset Search",
  查看评估记录: "View Assessment Record",
  删除评估记录: "Delete Assessment Record",

  // 评估表单 - 申请人信息
  申请人信息: "Applicant Information",
  员工姓名: "Employee Name",
  员工编号: "Employee Number",
  创建日期: "Creation Date",
  部门: "Department",
  岗位: "Position",
  邮箱: "Email",
  邮箱格式不正确: "Invalid Email Format",

  // 评估表单 - 供应商基本信息
  供应商基本信息: "Supplier Basic Information",
  "供应商名称（中文）": "Supplier Name (Chinese)",
  "供应商名称（英文）": "Supplier Name (English)",
  供应商状态: "Supplier Status",
  新供应商: "New Supplier",
  现有供应商: "Existing Supplier",
  物料状态: "Material Status",
  物料用途类别: "Material Category",
  原料: "Raw Material",
  辅料: "Auxiliary Material",
  包装材料: "Packaging Material",
  物料编号如有: "Material Number (if available)",
  注册市场: "Registration Market",
  中国内地: "Mainland China",
  中国香港: "Hong Kong",
  美国: "United States",
  其他: "Other",
  产地区域: "Production Area",
  中国: "China",
  欧美: "Europe and America",
  亚太: "Asia Pacific",

  // 通用提示
  请输入: "Please Enter",
  请选择: "Please Select",

  // 编辑表单 - VSMC会议评审
  VSMC会议评审: "VSMC Meeting Review",
  发起二维码审批: "Initiate QR Code Approval",
  审核意见: "Review Opinion",
  同意: "Agree",
  驳回: "Reject",
  需呈GM决策: "Submit to GM Decision",
  意见说明: "Opinion Description",
  请输入意见说明: "Please Enter Opinion Description",

  // 编辑表单 - 评审人签批
  评审人签批意见: "Reviewer Signature Opinion",
  刷新: "Refresh",
  未签批: "Not Signed",
  评审意见: "Review Opinion",
  暂无意见: "No Opinion",
  暂无备注: "No Remarks",

  // 编辑表单 - 评估详情
  暂无数据: "No Data",
  暂无该阶段的评估数据: "No Assessment Data for This Phase",
  暂无评估数据: "No Assessment Data",
  发送邀请: "Send Invitation",
  获取评估数据成功: "Assessment Data Retrieved Successfully",
  获取的评估数据中不包含该阶段的信息请重试:
    "The Retrieved Assessment Data Does Not Contain Information for This Phase, Please Try Again",
  总体评估结果: "Overall Assessment Result",
  评估详情: "Assessment Details",
  上一个阶段: "Previous Phase",
  下一个阶段: "Next Phase",
  优评: "Excellent Review",
  中评: "Medium Review",
  差评: "Poor Review",
  差: "Poor",
  中: "Medium",
  优: "Excellent",
  没有可用的form实例: "No Available Form Instance!",
  加载中: "Loading...",

  // 模态框标题
  供应商准入评估表: "Supplier Admission Assessment Form",
  单号: "Process Number",

  // 编辑模式按钮
  发起会议审批: "Initiate Meeting Approval",
  流程动态: "Process Timeline",

  // Tab 标签
  供应商准入评估: "Supplier Admission Assessment",
  我的评估: "My Assessment",
  评估邀请: "Assessment Invitation",

  // 评估状态
  评估中: "In Progress",
  已评估: "Assessed",
  未评估: "Not Assessed",

  // 表单标签和提示
  评估阶段: "Assessment Phase",
  评估人: "Assessor",
  请选择评估阶段: "Please Select Assessment Phase",
  请选择评估人: "Please Select Assessor",

  // 按钮和操作
  删除邀请: "Delete Invitation",
  确认要删除这条邀请吗: "Are you sure you want to delete this invitation?",
  确认: "Confirm",
  取消: "Cancel",
  删除成功: "Deleted Successfully",
  删除失败: "Delete Failed",
};
